import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var OrderDetailsRes;
export const OrderDetailsTodo = createAsyncThunk('OrderDetails', async (data) => {
// console.log(data)
    try {
        const res = await axios({
            method: "post",
            url: process.env.REACT_APP_API_URL + 'detail',
            data: {
                "vpurchase_order_code": data?.code,
                "icpom_master_id" : data?.id
            },
            headers: { "Content-Type": "application/json" }
        })
        return OrderDetailsRes = res.data

    } catch (error) {
        return OrderDetailsRes = error.response.data
    }
})

const OrderDetailsSlice = createSlice({
    name: 'OrderDetails',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(OrderDetailsTodo.fulfilled, (state, action) => {
            state.data = action.payload;
            // console.log('equipmentList', state.data.response)
        });
        builder.addCase(OrderDetailsTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default OrderDetailsSlice.reducer; 